import { render, staticRenderFns } from "./project_filter_deprecated.vue?vue&type=template&id=23171de6&"
import script from "./project_filter_deprecated.vue?vue&type=script&lang=js&"
export * from "./project_filter_deprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports